export default {
	expdigDiagnose: {
		deviceModel: 'Device Model',
                waveSpectrum: 'Waveform and Spectrum Plot',
                eigenvalue: 'Feature Values',
                multiWave: 'Multi-Waveform',
                timeDomainTrend: 'Multi-Trend of Time-Domain Indicators',
		multiSpectrum: 'Multi-Spectrum',
		envelopeDemod: 'Envelope Demodulation',
		orderAnalysis: 'Order Analysis',
		orderEnvelope: 'Order Envelope',
		waterfall: 'Waterfall Plot',
		cepstrum: 'Cepstrum',
		crossSpectrumPhase: 'Cross Spectrum Phase',
                multiSensorIndicator: 'Multi-Point Indicators',
                axisOrbit: 'Shaft Orbit',
		component: 'Component',
		healthLifePredict: 'Health & Life Prediction',
                singleValueBar: 'Single-Value Bar Chart',
		bodePlot: 'Bode Plot',
		multiParameter: 'Multi-Parameter Analysis',
                runStatus: 'Operating Status Diagram',
		indicatorDiagram: 'Indicator Diagram',
                pistonRodTrajectory: 'Piston Rod Trajectory Plot',
                stressMonitor: 'Stress Monitoring',
		impactDiag: 'Impact Diagnosis',
                vibrationMonitor: 'Vibration Monitoring',
		pistonRodSettlement: 'Piston Rod Settlement/Deflection',
		historyCompare: 'History Compare',
                otherParameter: 'Other Parameters',
                instantSpeedMonitor: 'Instantaneous Speed Monitoring',
		torsionalVibration: 'Torsional Vibration',
                orderAnalysisICE: 'Order Analysis (Internal Combustion Engine)',
                orderEnvelopeICE: 'Order Envelope (Internal Combustion Engine)',
		dcsTrend: 'Process Trend',
                // Quick options
		last1Day: 'Last 1 Day',
		last3Days: 'Last 3 Days',
		last7Days: 'Last 7 Days',
		last1Month: 'Last 1 Month',
		last3Months: 'Last 3 Months',
                // Tool menu
                trend: 'Trend Chart',
                wave: 'Waveform Chart',
                spectrum: 'Spectrum Chart',
		amplitudeSpeed: 'Amplitude-Speed',
		phaseSpeed: 'Phase-Speed',
		orderWave: 'Order Wave',
		orderSpectrum: 'Order Spectrum',
		envSpectrum: 'Envelope Spectrum',
		multiParameterAnalysis: 'Multi-Parameter Analysis',
		phaseDiffSpectrum: 'Phase Difference Spectrum',
		xAxisWave: 'X-Axis Sensor Wave',
		yAxisWave: 'Y-Axis Sensor Wave',
		dynamicPressureTrend: 'Dynamic Pressure Trend',
                // Tool buttons
		mark: 'Mark',
		export: 'Export',
		modelAnnotation: 'Model Annotation',
		dualCursor: 'Dual Cursor',
		sideFrequency: 'Side Frequency',
		filter: 'Filter',
		abnormalAnnotation: 'Abnormal Annotation',
		peakSpectrumTable: 'Peak Spectrum Table',
		frequencyBand: 'Frequency Band',
		multipleFrequency: 'Multiple Frequency',
		rotationFrequency: 'Rotation Speed',
		characteristicFrequency: 'Characteristic Frequency',
		// other
		gridLayout: 'Grid Layout',
		averageAmplitude: 'Average Amplitude',
		clearanceFactor: 'Clearance Factor',
		crestFactor: 'Crest Factor',
		impulseFactor: 'Impulse Factor',
		kurtosisFactor: 'Kurtosis Factor',
		maximum: 'Maximum',
		mean: 'Mean',
		minimum: 'Minimum',
		peak: 'Peak',
		peakToPeak: 'Peak to Peak',
		rms: 'RMS',
		rootAmplitude: 'Root Amplitude',
		shapeFactor: 'Shape Factor',
		skewnessFactor: 'Skewness Factor',
		wideband: 'Wideband',
		narrowband: 'Narrowband',
		// trendRef component
		time: 'Time',
		peakValue: 'Peak Value',
		rmsValue: 'RMS',
		// com-list component
		lowFrequency: 'Low Frequency',
		highFrequency: 'High Frequency',
		longWaveform: 'Long Waveform',
		selectAxial: 'Please select axial direction',
		selectedPoints: 'Selected {count} measurement points',
		noSelect: 'Not Selected',
		xAxisPoint: 'X-Axis Sensor',
		yAxisPoint: 'Y-Axis Sensor',
		startDate: 'Start Date',
		endDate: 'End Date',
		separator: ' - ',
		selectIndicator: 'Select Indicator',
		multiChart: 'Multi-Chart',
		singleChart: 'Single Chart',
		resetChart: 'Reset Chart',
		basicInfo: 'Basic Information',
		deviceOverview: 'Device Overview',
		deviceNumber: 'Device Number',
		deviceName: 'Device Name',
		deviceType: 'Device Type',
		productionArea: 'Production Area',
		deviceStatus: 'Device Status',
		health: 'Health',
		alarmLevel: 'Alarm Level',
		runtime: 'Runtime',
		alarmTotal: 'Alarm Total',
		lifePrediction: 'Life Prediction',
		month: 'Month',
		hour: 'h',
		running: 'Running',
		stop: 'Stop',
		offline: 'Offline',
		unknown: 'Unknown',
		normal: 'Normal',
		general: 'General',
		medium: 'Medium',
		severe: 'Severe',
		exportWaveButton: 'Export Waveform by Time Range'
	},
	treeCom: {
		searchPlaceholder: 'Enter device keyword',
		expandLevel: '{level}',
		levelList: ['One', 'Two', 'Three', 'Four'],
		allDevices: 'All Devices',
		online: 'Online',
		stop: 'Stop',
		offline: 'Offline'
	},
	fluidsChart: {
		startDate: 'Start Date',
		endDate: 'End Date',
		resetChart: 'Reset Chart'
	},
	comList: {
		pistonRodSettlement: 'Piston Rod Settlement & Deflection Sensor',
		cylinderSelection: 'Cylinder Selection'
	},
	collChart: {
		rawWave: 'Raw Wave',
		spectrum: 'Spectrum',
		waveform: 'Waveform',
		spectrumChart: 'Spectrum',
		trend: 'Trend',
		samplingFreq: 'Sampling Frequency',
		rpm: 'RPM',
		generalAlarm: 'General Alarm',
		mediumAlarm: 'Medium Alarm',
		severeAlarm: 'Severe Alarm',
		alarm: 'Alarm',
		exportDialogTitle: 'Export Waveform Data by Time Range',
		timeRange: 'Time Range',
		rangeSeparator: 'to',
		startTime: 'Start Time',
		endTime: 'End Time',
		collectType: 'Collection Type',
		highFrequencyOption: 'High Frequency (02)',
		lowFrequencyOption: 'Low Frequency (01)',
		longWaveformOption: 'Long Waveform (04)',
		exportTips: 'Up to 3000 sampling time points can be exported at a time. If exceeded, please narrow the time range and export in batches. Large data volumes may take a long time, please wait patiently.',
		cancel: 'Cancel',
		confirmExport: 'Confirm Export',
		timeRangeInvalid: 'Invalid time range',
		selectTimeRange: 'Please select a time range',
		exportFailed: 'Export failed',
		exportSuccess: 'Export successful',
		exportFailedRetry: 'Export failed, please try again'
	},
	barChart: {
		noChartData: 'No Chart Data',
		status: 'Status',
		normal: 'Normal',
		warning: 'Warning',
		danger: 'Danger'
	},
	bodeChart: {
		phase: 'Phase',
		amplitude: 'Amplitude',
		rawData: 'Raw Data',
		tongpin: 'Overall',
		oneXFreq: '1X Frequency',
		twoXFreq: '2X Frequency',
		halfXFreq: '0.5X Frequency'
	},
	crossChart: {
		phaseDiffSpectrum: 'Phase Difference Spectrum',
		amplitudeSpectrum: 'Amplitude Spectrum',
		samplingFreq: 'Sampling Frequency',
		crossPoint: 'Cross Point'
	},
	crewSidebar: {
		deviceName: 'Device Name',
		sensorSelection: 'Sensor Selection',
		compareType: 'Compare Type',
		samePoint: 'Same Point',
		diffPoint: 'Different Points'
	},
	diagnoseSidebar: {
		deviceName: 'Device Name',
		sensorSelection: 'Sensor Selection',
		pistonRodTrajectory: 'Piston Rod Trajectory'
	},
	eigTags: {
		selectAll: 'Select All'
	},
	eigMultSingle: {
                featureValue: 'Feature Values'
	},
	eigMultsSingle: {
		multiPointIndicator: 'Multi-Point Indicator'
	},
	fludisTrends: {
		indicatorDataTable: 'Indicator Data Statistics Table',
		time: 'Time',
		export: 'Export'
	},
	envCom: {
		envelopeSpectrum: 'Envelope Spectrum',
		spectrum: 'Spectrum',
		samplingFreq: 'Sampling Frequency',
		demodFreqBand: 'Demodulation Frequency Band'
	},
	filterCom: {
		filterConfig: 'Filter Configuration',
		cancel: 'Cancel',
		confirm: 'Confirm',
		filter: 'Filter'
	},
	historyCompare: {
		historyTrend: 'History Trend Chart',
		historyWave: 'History Waveform Chart',
		mark: 'Mark',
		export: 'Export',
		noData: 'No Data',
		second: 'Second',
		time: 'Time'
	},
	healthLife: {
		deviceHealth: 'Device Health',
		remainingLife: 'Remaining Life Prediction',
		healthTrendAnalysis: 'Device Health Trend Analysis',
		lifePredictionTrend: 'Remaining Life Prediction Trend',
		last1Month: 'Last 1 Month',
		last3Months: 'Last 3 Months',
		last6Months: 'Last 6 Months',
		last1Year: 'Last 1 Year',
		refresh: 'Refresh',
		healthDetailAnalysis: 'Health Detail Analysis',
		impactFactorAnalysis: 'Impact Factor Analysis',
		factor: 'Factor',
		weight: 'Weight',
		currentValue: 'Current Value',
		normalRange: 'Normal Range',
		impactDegree: 'Impact Degree',
		maintenanceSuggestions: 'Maintenance Suggestions',
		excellent: 'Excellent',
		good: 'Good',
		normal: 'Normal',
		poor: 'Poor',
		sufficient: 'Sufficient',
		needAttention: 'Need Attention',
		needReplace: 'Need Replace',
		rise: 'Rise',
		drop: 'Drop',
		stable: 'Stable',
		healthDataUpdated: 'Health data updated',
		lifeDataUpdated: 'Life prediction data updated',
		excellentLine: 'Excellent Line',
		goodLine: 'Good Line',
		warningLine: 'Warning Line',
		maxValue: 'Maximum',
		minValue: 'Minimum',
		remainingLifePrediction: 'Remaining Life Prediction',
		predictedValue: '(Predicted)',
		month: 'Month'
	},
	multChart: {
		rawWave: 'Raw Wave',
		spectrum: 'Spectrum',
		cepstrum: 'Cepstrum',
		crossPhase: 'Cross Phase',
		waveform: 'Waveform',
		samplingFreq: 'Sampling Frequency'
	},
	indicatorDiagram: {
		dynamicPressureTrend: 'Dynamic Pressure Trend Chart',
		waveformChart: 'Waveform Chart',
		time: 'Time',
		noData: 'No Data',
		exhaustShadow: 'Exhaust Shadow',
		intakeShadow: 'Intake Shadow',
		exhaustShadowArea: 'Exhaust Shadow Area',
		intakeShadowArea: 'Intake Shadow Area'
	},
	indicatorSidebar: {
		deviceName: 'Device Name',
		compareType: 'Compare Type',
		sameSidePoint: 'Same Side Point',
		diffPoint: 'Different Points',
		sensorSelection: 'Sensor Selection',
		diagramSelection: 'Diagram Selection'
	},
	multParameter: {
		generalAlarm: 'General Alarm',
		mediumAlarm: 'Medium Alarm',
		severeAlarm: 'Severe Alarm',
		alarm: 'Alarm',
		pistonRodSettlement: 'Piston Rod Settlement (um)',
		dynamicPressure: 'Dynamic Pressure (kPa)',
		vibrationAcceleration: 'Vibration Acceleration (m/s2)',
		multiParameterAnalysis: 'Multi-Parameter Analysis (Angle/Value)',
		angle: 'Angle (°)',
		orderWave: 'Order Wave',
		orderSpectrum: 'Order Spectrum',
		samplingFreq: 'Sampling Frequency',
		rpm: 'RPM',
		turns: 'Turns(n)'
	},
	multTrends: {
		indicatorDataTable: 'Indicator Data Statistics Table',
		time: 'Time',
		export: 'Export',
		timeDomainIndicatorMultiTrend: 'Time Domain Indicator Multi-Trend'
	},
	orderAnalysis: {
		trendChart: 'Trend Chart',
		orderWave: 'Order Wave',
		orderSpectrum: 'Order Spectrum',
		mark: 'Mark',
		export: 'Export',
		time: 'Time',
		turns: 'Turns(n)',
		waveform: 'Waveform',
		spectrum: 'Spectrum',
		trend: 'Trend',
		generalAlarm: 'General Alarm',
		mediumAlarm: 'Medium Alarm',
		severeAlarm: 'Severe Alarm',
		alarm: 'Alarm',
		samplingFreq: 'Sampling Frequency',
		rpm: 'RPM'
	},
	orderEnvelope: {
		trendChart: 'Trend Chart',
		orderEnvelopeWave: 'Order Envelope Wave',
		orderEnvelopeSpectrum: 'Order Envelope Spectrum',
		mark: 'Mark',
		export: 'Export',
		time: 'Time',
		turns: 'Turns(n)',
		waveform: 'Waveform',
		spectrum: 'Spectrum',
		trend: 'Trend',
		generalAlarm: 'General Alarm',
		mediumAlarm: 'Medium Alarm',
		severeAlarm: 'Severe Alarm',
		alarm: 'Alarm',
		samplingFreq: 'Sampling Frequency',
		rpm: 'RPM'
	},
	otherParameters: {
                otherParameterTrend: 'Other Parameters Trend Chart',
		unknownPoint: 'Unknown Point',
		trendChart: 'Trend Chart'
	}
}
